export class TipoDocumento {
    ntipdocumentoId: number;
    ctipdocumentoDsc: string;
    ctipdocumentoMask: string;
  }

